/* eslint-disable jsx-control-statements/jsx-use-if-tag */
import React, { useEffect, useState } from 'react'
import './profile.scss'
import './_unifiedlogin.scss'
import './Handlepiclick'

import { isEmpty } from 'AccountsUtils'

import { getLinkedEmailsList } from '../../pages/Trips/trips.helper'

import { MLContainers } from '../../newComponents/UnifiedLogin'

const EmailContainer = ({
  setIsPOpaque = () => {},
  setIsGOpaque = () => {},
  setIsMOpaque = () => {},
  isEOpaque,
  userDetail,
  setUserDetail,
  setToastMessagex,
  setIsEmailLinked,
  isEmailLinked
}) => {
  const [page, setPageName] = useState('')
  const [isEmailEditable, setIsEmailEditable] = useState(true)
  const [newEmail, setNewEmail] = useState('')

  const [existingCtEmails, setExistingCtEmails] = useState()

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    userDetail?.username && setNewEmail(userDetail?.username)
  }, [userDetail])

  const hasOldCTEmails = async (action = '') => {
    if (userDetail?.username) {
      return false
    }
    const oldCTEmailResp = await getLinkedEmailsList({
      mobile: userDetail ? userDetail.mobile : '',
      countryCode: '+91'
    })

    const { status: dataStatus, data: oldCTEmailData = [] } =
      oldCTEmailResp || {}

    if (dataStatus === 200 && !isEmpty(oldCTEmailData)) {
      setExistingCtEmails(oldCTEmailData.users)
      return true
    }
    setExistingCtEmails()
    return false
  }

  const handleEmailClick = async () => {
    if (await hasOldCTEmails() && !isEmpty(existingCtEmails)) {
      setPageName('EMAIL_LINKEDML')
    } else {
      setPageName('SIGNIN_EMAILML')
    }

    setIsEmailEditable(false)
    setIsMOpaque(true)
    setIsGOpaque(true)
    setIsPOpaque(true)
  }
  const handleIsShowing = () => {}
  return (
    <>
      {isEmailEditable ? (
        <div
          className={` mt-3 fs-2 c-grey-title ${
            isEOpaque ? 'op-low' : 'op-high'
          }`}
        >
          Email Address
          <div className="flex flex-row">
            {newEmail === '' ? (
              <>
                <span className="fs-4 " style={{ color: '#B3B3B3' }}>
                  Not provided
                </span>
                <div className="heading5">
                  <a onClick={handleEmailClick}>Add</a>
                </div>
              </>
            ) : (
              <>
                <span className="fs-4 fw-500" style={{ color: '#1A1A1A' }}>
                  {newEmail}
                </span>
                <div className="heading5">
                  <a onClick={handleEmailClick}>Edit</a>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="mt-6">
          <MLContainers
            page={page}
            isShowing={true}
            handleIsShowing={handleIsShowing}
            setIsEmailEditable={setIsEmailEditable}
            isEmailEditable={isEmailEditable}
            setIsGOpaque={setIsGOpaque}
            setIsPOpaque={setIsPOpaque}
            setIsMOpaque={setIsMOpaque}
            existingCtEmails={existingCtEmails}
            setNewEmail={setNewEmail}
            userDetail={userDetail}
            setUserDetail={setUserDetail}
            setToastMessagex={setToastMessagex}
            setIsEmailLinked={setIsEmailLinked}
            isEmailLinked={isEmailLinked}
          />
        </div>
      )}
    </>
  )
}
export default EmailContainer
